import { type SuccessResponse } from '../../models/common.js';
import {
  type CreateValues,
  type FindAllOptions,
  type PracticeConfig,
  type UpdateValues,
} from '../../models/orchestrator/practiceConfig/index.js';
import { type PaginatedQueryOptions } from '../../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../../models/pagination/PaginationResponse.type.js';
import OrchestratorAPI from '../common.js';

export default class API extends OrchestratorAPI {
  public readonly API_PATH = '/practice-configs';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findAll(options: FindAllOptions = {}): Promise<PracticeConfig[]> {
    const url = this.constructPath('/', options);
    const { practiceConfigs } = await this.common.getJSON(url);
    return practiceConfigs;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<PracticeConfig>> {
    const url = this.constructPath('/', options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PracticeConfig> {
    const url = this.constructPath(`/${id}`);
    const { practiceConfig } = await this.common.getJSON(url);
    return practiceConfig;
  }

  async create(toAdd: CreateValues): Promise<PracticeConfig> {
    const url = this.constructPath('/');
    const { practiceConfig } = await this.common.postJSON(url, toAdd);
    return practiceConfig;
  }

  async update(id: string, args: UpdateValues): Promise<PracticeConfig> {
    const url = this.constructPath(`/${id}`);
    const { practiceConfig } = await this.common.patchJSON(url, args);
    return practiceConfig;
  }

  async remove(id: string): Promise<SuccessResponse> {
    const url = this.constructPath(`/${id}`);
    return await this.common.deleteJSON(url);
  }
}
